import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/logistics/carrier';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {

	/** @namespace state.lists.carrierIds **/
	/** @namespace state.maps.carrier **/
	/** @namespace state.maps.user **/
	let carriers = [];
	if (state.lists.carrierIds) {
		carriers = _.map(state.lists.carrierIds, id => state.maps.carrier[id]);
	}
	return {
		carriers : _.sortBy(carriers, 'name'),
		authUser : state.auth.authUser,
		userMap : state.maps.user,
		quickbooksVendorMap : state.maps.quickbooksVendor,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchCarriers : search,
	removeCarrier : remove,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);